import ConversationService from "utilities/services/conversations/conversation-service";
import { Dispatch } from "react";
import { ResultRecord, StringUtils } from "@rsm-hcd/javascript-core";
import { ConversationHistoryAction } from "./conversation-history-atom-reducer";

/**
 * Deletes a conversation.
 * This thunk will delete a conversation and update the state accordingly.
 */
export const deleteConversation =
    (id: string) => async (dispatch: Dispatch<ConversationHistoryAction>) => {
        dispatch({ type: "DELETE_CONVERSATION", id });

        let result: ResultRecord<boolean> | undefined;

        try {
            if (StringUtils.isEmpty(id)) {
                dispatch({
                    type: "ERROR",
                    error: new Error(
                        "Conversation ID is required to delete a conversation."
                    ),
                });
                return;
            }

            await ConversationService.delete(id);

            return;
        } catch (error) {
            result = new ResultRecord<boolean>().addError("ERROR", `${error}`);

            dispatch({
                type: "ERROR",
                error: new Error(
                    (
                        result?.listErrorMessages() || [
                            "Failed to delete conversation",
                        ]
                    ).join(", ")
                ),
            });

            return;
        }
    };
